import { GameManager } from "../../GameManager";
import { GameConstants } from "../../GameConstants";
import { GameVars } from "../../GameVars";
import { AudioManager } from "../../AudioManager";

export class WinLayer extends Phaser.GameObjects.Container {

    constructor(scene: Phaser.Scene) {
        super(scene);

        let numStars = GameVars.currentStars;

        const bck = new Phaser.GameObjects.Graphics(this.scene);
        bck.fillStyle(0x000000);
        bck.fillRect(0, 0, GameConstants.GAME_WIDTH, GameConstants.GAME_HEIGHT);
        bck.setInteractive(new Phaser.Geom.Rectangle(0, 0, GameConstants.GAME_WIDTH, GameConstants.GAME_HEIGHT), Phaser.Geom.Rectangle.Contains);
        bck.on("pointerdown", () => { 
            // 
        });
        bck.alpha = 0;
        this.add(bck);

        let midContainer = new Phaser.GameObjects.Container(this.scene);
        midContainer.setPosition(GameConstants.GAME_WIDTH / 2, GameConstants.GAME_HEIGHT / 2 - 100);
        midContainer.scaleX = GameVars.scaleX;
        this.add(midContainer);

        let kingContainer = new Phaser.GameObjects.Container(this.scene);
        kingContainer.setScale(.7);
        kingContainer.alpha = 0;
        midContainer.add(kingContainer);

        let flare = new Phaser.GameObjects.Image(this.scene, 0, -10, "texture_atlas_1", "flare_orange");
        flare.setScale(6);
        kingContainer.add(flare);

        let king = new Phaser.GameObjects.Image(this.scene, 0, -10, "texture_atlas_1", "king_portrait_victory_0" + numStars);
        kingContainer.add(king);

        if (numStars === 3) {
            let leftHand = new Phaser.GameObjects.Image(this.scene, -110, 65, "texture_atlas_1", "king_portrait_hand_03");
            leftHand.setOrigin(.5, 1);
            leftHand.angle = 3;
            leftHand.scaleX = -1;
            kingContainer.add(leftHand);

            let rightHand = new Phaser.GameObjects.Image(this.scene, 110, 65, "texture_atlas_1", "king_portrait_hand_03");
            rightHand.setOrigin(.5, 1);
            rightHand.angle = -3;
            kingContainer.add(rightHand);

            this.scene.tweens.add({
                targets: leftHand,
                angle: 9,
                ease: Phaser.Math.Easing.Linear,
                duration: 250,
                repeat: -1,
                yoyo: true
            });
    
            this.scene.tweens.add({
                targets: rightHand,
                angle: -9,
                ease: Phaser.Math.Easing.Linear,
                duration: 250,
                repeat: -1,
                yoyo: true
            });
        }

        let stars = new Phaser.GameObjects.Image(this.scene, 0, -140, "texture_atlas_1", "stars_end_level_bg");
        stars.visible = false;
        kingContainer.add(stars); 

        for (let i = 0; i < numStars; i++) {
            this.scene.time.addEvent({ delay: 1500 + 500 * i, callback: () => {

                stars.visible = true;

                let star = new Phaser.GameObjects.Image(this.scene, 0, -140, "texture_atlas_1", "stars_end_level_" + (i + 1));
                star.setScale(.75);
                star.alpha = 0;
                midContainer.add(star);

                AudioManager.playSound("star_appears", false, 1, .8 + i * .2);

                this.scene.tweens.add({
                    targets: star,
                    alpha: 1,
                    scaleX: 1,
                    scaleY: 1,
                    ease: Phaser.Math.Easing.Cubic.Out,
                    duration: 250
                });

                coins.setText(GameVars.formatNumber(GameVars.coinsBaseEarned + (GameVars.coinsEarned / numStars) * (i + 1)));

                this.scene.tweens.add({
                    targets: flare,
                    scaleX: 7 + .5 * i,
                    scaleY: 7 + .5 * i,
                    ease: Phaser.Math.Easing.Back.Out,
                    duration: 250
                });

                if (i === 2) {
                    AudioManager.playSound("new_level_unlocked");
                }

            }, callbackScope: this});
        }

        const titleBck = new Phaser.GameObjects.Image(this.scene, 0, 115, "texture_atlas_1", "campaign_" + (GameVars.currentMapZone + 1));
        titleBck.scaleX  = .25;
        titleBck.alpha = 0;
        midContainer.add(titleBck);

        const title = new Phaser.GameObjects.Image(this.scene, 0, 102, "texture_atlas_1", "victory_text");
        title.scaleX = .25;
        title.alpha = 0;
        midContainer.add(title);

        const capsule = new Phaser.GameObjects.Image(this.scene, 0, 205, "texture_atlas_1", "capsule_coins_end_level");
        capsule.alpha = 0;
        midContainer.add(capsule);

        const numCoins = GameVars.formatNumber(GameVars.coinsBaseEarned);

        const coins = new Phaser.GameObjects.Text(this.scene, 60, 203,  numCoins, {fontFamily: "Dalek", fontSize: "36px", color: "#FFB519", align: "center"});
        coins.setOrigin(1, .5);
        coins.setShadow(4, 0, "#2D3441");
        coins.alpha = 0;
        midContainer.add(coins);

        const homeButton = new Phaser.GameObjects.Image(this.scene, 0, 300, "texture_atlas_1", "btn_menu");
        homeButton.setInteractive();
        homeButton.on("pointerover", () => { this.onBtnOver(homeButton); });
        homeButton.on("pointerout", () => { this.onBtnOut(homeButton); });
        homeButton.on("pointerdown", () => { this.onClickHome(); });
        homeButton.alpha = 0;
        midContainer.add(homeButton);

        this.scene.tweens.add({
            targets: bck,
            alpha: .75,
            ease: Phaser.Math.Easing.Cubic.Out,
            duration: 1500
        });

        this.scene.tweens.add({
            targets: [titleBck, title],
            alpha: 1,
            scaleX: 1,
            scaleY: 1,
            ease: Phaser.Math.Easing.Back.Out,
            duration: 350,
            delay: 600,
            onStart: () => {
                AudioManager.playSound("banner_unroll");
            },
            onStartScope: this
        });

        this.scene.tweens.add({
            targets: kingContainer,
            scaleX: 1,
            scaleY: 1,
            ease: Phaser.Math.Easing.Back.Out,
            duration: 500,
            delay: 1000,
        });

        this.scene.tweens.add({
            targets: kingContainer,
            alpha: 1,
            ease: Phaser.Math.Easing.Cubic.Out,
            duration: 500,
            delay: 1000,
        });

        this.scene.tweens.add({
            targets: [capsule, coins],
            alpha: 1,
            ease: Phaser.Math.Easing.Cubic.Out,
            duration: 500,
            delay: 1000
        });

        this.scene.tweens.add({
            targets: homeButton,
            alpha: 1,
            ease: Phaser.Math.Easing.Back.Out,
            duration: 500,
            delay: numStars * 500 + 1500
        });

        this.scene.tweens.add({
            targets: homeButton,
            scaleX: 1.125,
            scaleY: 1.125,
            ease: Phaser.Math.Easing.Cubic.InOut,
            duration: 350,
            repeat: -1,
            yoyo: true
        });

        AudioManager.setSoundtrackVolume(0);

        this.scene.time.delayedCall(4250, function(): void {
            AudioManager.playSoundtrack("soundtrack_menus", .25);
        }, [], this);

        this.scene.time.delayedCall(250, function(): void {
            AudioManager.playSound("you_win");
        }, [], this);
    }

    private onBtnOver(btn: any): void {

        if (btn.alpha === 1) {
            btn.setScale(1.1);
        }
    }

    private onBtnOut(btn: any): void {
        
        if (btn.alpha === 1) {
            btn.setScale(1);
        }
    }

    private onClickHome(): void {

        GameManager.enterLobbyScene();

        AudioManager.playSound("btn_click");
    }
}
